(function () {
(($)=>{
    $(document).ready(function() {
        const $presSection = $(".presentation");
        const $presBtn = $presSection.find(".presentation__btn");
        if (!$presSection.length || !$presBtn.length) return;
        const mq = window.matchMedia("(min-width: 1280px)");
        let enabled = mq.matches;
        let tx = 0, ty = 0, cx = 0, cy = 0;
        const maxTravel = 120;
        const magneticRadius = 400;
        let btnRestX = 0, btnRestY = 0;
        const updateRest = ()=>{
            const r = $presBtn[0].getBoundingClientRect();
            btnRestX = r.left + r.width / 2;
            btnRestY = r.top + r.height / 2;
        };
        updateRest();
        $(window).on("resize scroll", updateRest);
        // Activer/désactiver selon le breakpoint
        mq.addEventListener("change", (e)=>{
            enabled = e.matches;
            if (!enabled) {
                // Reset des positions
                tx = 0;
                ty = 0;
                cx = 0;
                cy = 0;
                $presBtn.css("transform", "translate3d(0, 0, 0)");
                $presBtn.find(".presentation__btn-text, .presentation__btn-arrow").css("transform", "rotate(0deg)");
                $presBtn.removeClass("is-hovered");
            }
        });
        $presSection.on("mouseleave", ()=>{
            tx = 0;
            ty = 0;
        });
        $presSection.on("mousemove", (e)=>{
            if (!enabled) return;
            const dx = e.clientX - btnRestX;
            const dy = e.clientY - btnRestY;
            const dist = Math.sqrt(dx * dx + dy * dy);
            // Effet magnétique : attire le bouton vers le curseur
            // Plus le curseur est proche, plus l'attraction est forte (inverse de l'ancien comportement)
            if (dist < magneticRadius) {
                const strength = 1 - dist / magneticRadius; // 1 (proche) → 0 (loin)
                tx = dx * strength;
                ty = dy * strength;
            } else {
                tx = 0;
                ty = 0;
            }
            // Détection de survol sur la position visuelle réelle du bouton
            const br = $presBtn[0].getBoundingClientRect();
            const bdist = Math.hypot(e.clientX - (br.left + br.width / 2), e.clientY - (br.top + br.height / 2));
            $presBtn.toggleClass("is-hovered", bdist < br.width * 0.7);
        });
        // Lerp adaptatif : plus rapide quand l'écart est grand (évite la "fuite" du bouton)
        const lerp = (a, b, t)=>a + (b - a) * t;
        const animate = ()=>{
            if (enabled) {
                const gapX = Math.abs(cx - tx);
                const gapY = Math.abs(cy - ty);
                const totalGap = gapX + gapY;
                // Facteur entre 0.15 (proche) et 0.6 (loin) pour une réactivité accrue
                const factor = Math.min(0.15 + totalGap / 150, 0.6);
                cx = lerp(cx, tx, factor);
                cy = lerp(cy, ty, factor);
                $presBtn.css("transform", `translate3d(${cx.toFixed(1)}px, ${cy.toFixed(1)}px, 0)`);
                const rot = cx * 0.03;
                $presBtn.find(".presentation__btn-text, .presentation__btn-arrow").css("transform", `rotate(${rot.toFixed(2)}deg)`);
            }
            requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
    });
})(jQuery);

})();
//# sourceMappingURL=presentation.js.map
